const pages: Record<string, string> = {
  // Quote form
  'form.title': 'Request a quote',
  'form.intro': 'Tell us what you are selling and where. We will confirm which approvals apply and reply with a scope and quote.',
  'form.name': 'Your name',
  'form.company': 'Company',
  'form.email': 'Work email',
  'form.service': 'What do you need?',
  'form.opt.0': 'Radio / wireless (Wi-Fi, Bluetooth, etc.)',
  'form.opt.1': 'EMC',
  'form.opt.2': 'Safety mark',
  'form.opt.3': 'More than one of these',
  'form.opt.4': 'Not sure yet',
  'form.markets': 'Countries you want to sell in',
  'form.marketsPlaceholder': 'e.g. Mexico, Brazil, South Africa',
  'form.product': 'Product and model (optional)',
  'form.productPlaceholder': 'e.g. Wi-Fi 6 router, model X100, 2.4 and 5 GHz',
  'form.error': 'We could not send your request. Please try again, or email us directly',
  'form.errorAt': ' at {{email}}',
  'form.errorEnd': '.',
  'form.send': 'Send request',
  'form.sending': 'Sending...',
  'form.thanksTitle': 'Thanks, we have your request',
  'form.thanksText': 'We will review the product and markets you listed and reply by email.',

  // Countries
  'countries.title': 'Countries we cover',
  'countries.intro': 'Radio, EMC and safety approvals, handled with local partners in each market. Select a country to see what is required there.',
  'countries.notListed': 'Selling somewhere not listed? Tell us below and we will check.',
  'country.notFound': 'We could not find that country',
  'country.seeAll': 'See the countries we cover',
  'country.breadcrumb': 'Countries',
  'country.authority': 'Authority:',
  'country.verified': 'Last verified on {{date}}.',
  'country.partner': 'In partnership with',
  'country.keyPoints': 'What you need to know',
  'country.note': 'Requirements change and depend on the product. We confirm the current rules for your product before we quote.',
  'country.process': 'How we handle it',
  'country.quoteTitle': 'Selling in {{name}}? Get a quote',

  // News
  'news.title': 'Regulatory updates',
  'news.intro': 'Changes to approval rules in the markets we cover, with what they mean for your products.',
  'news.empty': 'No updates yet. Use the form below and we will tell you when something changes in your markets.',
  'news.whatToDo': 'What to do:',
  'news.source': 'Read the regulator’s announcement',
  'news.formTitle': 'Does an update affect your product?',
  'news.formIntro': 'Send us the model and the countries. We will tell you what applies, free of charge.',
};
export default pages;
